import { adminHttpClient } from '../../commons/adminHttpClient'

export type GetProductsToBuyResponse = {
  id: number
  description: string
  name: string
  companyId: string
  isInUse: boolean
  subscriptionPackageId: string
  crossSaleDiscountCode?: string
  crossSaleDiscountCodeYearly?: string
  defaultCrossSaleDiscountCode?: string
}

const getProductsToBuy = (): Promise<GetProductsToBuyResponse[]> => {
  return adminHttpClient.get(`/Products/productsToBuy`)
}

export default getProductsToBuy
